export default {
  Title: 'Offers | Offer | Offers',

  OnePlusOne: '💥1+1💥'
}
